<template lang="pug">
.spinner--wrapper
  .spinner
</template>

<script>
export default {
  name: 'spinner',
};
</script>

<style lang="scss" scoped>
// https://projects.lukehaas.me/css-loaders/
.spinner--wrapper {
  padding: 5rem 0 0 0;
}
.spinner,
.spinner:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.spinner {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<style theme="ffc" lang="scss" scoped>
.spinner {
  border-top: 1.1em solid rgba(32,126,173, 0.2);
  border-right: 1.1em solid rgba(32,126,173, 0.2);
  border-bottom: 1.1em solid rgba(32,126,173, 0.2);
  border-left: 1.1em solid #207ead;
}
</style>

<style theme="cwo" lang="scss" scoped>
.spinner {
  border-top: 1.1em solid rgba(255,255,255, 0.5);
  border-right: 1.1em solid rgba(255,255,255, 0.5);
  border-bottom: 1.1em solid rgba(255,255,255, 0.5);
  border-left: 1.1em solid $primary;
}
</style>
